<template>
  <div class="add-question">
    <pageTitle :pageTitle="`${title}表单`">
      <!-- <div class="headBtnGroup">
        <vh-button type="text" @click="openSet" class="name_set_button">
          修改「表单」显示名称
        </vh-button>
        <i class="iconfont-v3 saasicon_help_m" @click="showPreview"></i>
      </div> -->
    </pageTitle>
    <question
      ref="questions"
      :alias="alias"
      addTitle="点击左侧内容创建表单"
      :isPlayBackSet="false"
    ></question>

    <!-- 别名设置弹框 -->
    <VhallDialog
      title="提示"
      :visible.sync="dialogNameSet"
      :close-on-click-modal="false"
      class="zdy-async-dialog"
      width="400px"
    >
      <div class="async__body">
        <div class="async__ctx">
          <vh-input
            v-model="alias"
            :placeholder="'请输入名称'"
            maxlength="8"
            v-clearEmoij
            show-word-limit
          ></vh-input>
          <p class="setname_tip">
            可将名称修改为「投票」「报名」等，修改后用户观看直播时看到的是修改后的名称。
          </p>
        </div>
        <div class="async__footer">
          <vh-button type="info" plain size="medium" @click="saveNewName('cancel')" round>
            取消
          </vh-button>
          <vh-button type="primary" size="medium" @click="saveNewName" round>保存</vh-button>
        </div>
      </div>
    </VhallDialog>
    <!-- 图列展示弹框 -->
    <VhallDialog
      :visible.sync="dialogPreview"
      :modalClick="true"
      :show-close="true"
      class="zdy-dialog"
      width="740px"
    >
      <div class="img_base">
        <img src="@/views/LiveModule/MaterialSet/images/Q_preview.png" alt="" />
      </div>
    </VhallDialog>
  </div>
</template>
<script>
  import PageTitle from '@/components/PageTitle';
  import question from '@/components/Question/question';
  export default {
    data() {
      return {
        alias: '',
        dialogNameSet: false,
        dialogPreview: false
      };
    },
    components: {
      PageTitle,
      question
    },
    name: 'addQuestion.vue',
    computed: {
      title() {
        if (this.$route.query.questionId) {
          return '编辑';
        } else {
          return '创建';
        }
      }
    },
    methods: {
      showPreview() {
        this.dialogPreview = true;
        console.log('%c 展示例图', 'color:blue');
      },
      openSet() {
        this.dialogNameSet = true;
        // 资料管理 - 被同步后的数据，编辑的时候反显
        this.alias = this.alias || this.$route.query.alias || '表单';
        console.log('%c 打开别名设置弹框', 'color:blue');
      },
      saveNewName(data) {
        this.dialogNameSet = false;
        if (data == 'cancel') {
          this.alias = this.$route.query.alias || '表单';
        }
        console.log(this.$route.query);
      }
    }
  };
</script>

<style lang="less" scoped>
  #settingBox /deep/ .control-area {
    width: 185px;

    .categroys {
      border-bottom: 1px dashed #fb3a32;
      &:last-child {
        border-bottom: 0;
      }
    }
  }

  .headBtnGroup {
    float: right;
    .name_set_button {
      margin-right: 8px;
      color: #3562fa;
    }
  }
</style>
<style lang="less">
  .add-question .zdy-dialog {
    .img_base {
      padding: 4px;
      border-radius: 4px;
      background: #000;
      img {
        width: 100%;
      }
    }
  }
  .setname_tip {
    margin-top: 10px;
    color: #666 !important;
  }
</style>
